'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _CheckCircleOutlined = _interopRequireDefault(require('./lib/icons/CheckCircleOutlined'));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}
var _default = _CheckCircleOutlined;
exports.default = _default;
module.exports = _default;